import { motion } from 'framer-motion';
import { Target, Brain, Zap, Shield, Crown, Users } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { WHY_FEATURES } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

const ICONS = { Target, Brain, Zap, Shield, Crown, Users };

export default function Why() {
  return (
    <section id="why" className="relative py-24 sm:py-32 bg-night overflow-hidden" data-testid="why-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(230,57,70,0.06),transparent_50%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="01"
          eyebrow="Why Abu Zama?"
          title={'MORE THAN\nSOCCER.'}
          description="At Abu Zama Soccer Academy, we believe great players are developed through more than technical training. We develop complete athletes by combining soccer excellence with discipline, confidence, character and leadership."
          testId="why-heading"
        />
        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {WHY_FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <motion.div
                key={f.title}
                variants={fadeUp} custom={i}
                whileHover={{ y: -6 }}
                className="glass-card rounded-sm p-8 group hover:border-brand-gold/40 transition-[border-color,transform] duration-300"
                data-testid={`why-card-${f.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-brand-red/10 border border-brand-red/25 text-brand-red group-hover:text-brand-gold group-hover:border-brand-gold/40 group-hover:bg-brand-gold/10 transition-colors duration-300">
                  <Icon size={22} strokeWidth={1.75} />
                </div>
                <h3 className="mt-6 font-display text-2xl tracking-wide text-white uppercase">{f.title}</h3>
                <p className="mt-3 text-sm sm:text-base text-gray-400 leading-relaxed">{f.text}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
